export const getUserRole = () => {
  try {
    const storedUser = localStorage.getItem("adminUser");
    return storedUser ? JSON.parse(storedUser) : null;
  } catch (e) {
    return null;
  }
};
  
